import { Column } from 'primereact/column';
import { renderCell } from '../../../../../component/data-table/operations/render-cell';
import { getCellForCourseStatus } from '../../courses/operations/get-cell-for-course-status';
import { DataTable } from 'primereact/datatable';
import React, { useState } from 'react';
import { CourseMetadataType } from '../../../../../api/types/programs/course/course-metadata.type';
import dateUtils from '../../../../../utils/date-format';

interface ProgramSelectCoursesModel {
  courses: CourseMetadataType[];
  onSelectChange: (courses: CourseMetadataType[]) => any;
}
export const ProgramSelectCourses: React.FC<ProgramSelectCoursesModel> = ({
  courses,
  onSelectChange,
}) => {
  const [selectedCourses, setSelectedCourses] = useState<CourseMetadataType[]>(
    [],
  );

  return (
    <div>
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode={'multiple'}
        multiple={true}
        value={courses}
        onSelectionChange={(e) => {
          setSelectedCourses(e.value as CourseMetadataType[]);
          onSelectChange(e.value as CourseMetadataType[]);
        }}
        selection={selectedCourses}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '8px',
        }}
        style={{ marginTop: '16px' }}
        /*header={header}*/
        filterDisplay="row"
        /*        filters={filters}
        onFilter={(e) => setFilters(e.filters)} // Update filters dynamically*/
      >
        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
        <Column
          style={{ textAlign: 'right' }}
          field="abstractData.courseName"
          header="שם הקורס"
          filter
          filterField="abstractData.courseName"
          filterPlaceholder="חפש לפי        שם הקורס"
          filterMatchMode="contains"
          showFilterMenu={false}
        />
        <Column
          field="capacityHours"
          header="מכסת שעות"
          sortable
          style={{ textAlign: 'right' }}
        />
        <Column
          field="status"
          header="סטטוס"
          style={{ textAlign: 'right' }}
          body={(rowData) => {
            return renderCell(getCellForCourseStatus(rowData.status));
          }}
        />
        <Column
          field="abstractData.attendancePercentage"
          sortable
          filter
          header="אחוז נוכחות"
          style={{ textAlign: 'right' }}
          filterField="abstractData.attendancePercentage"
          filterPlaceholder="חפש לפי שם "
          filterMatchMode="contains" // Ensures it filters by text containment
          showFilterMenu={false}
        />
        <Column
          field="courseStartDate"
          header="תאריך התחלה"
          sortable
          style={{ textAlign: 'right' }}
          body={(rowData) => {
            if (!rowData.courseStartDate) {
              return <span style={{ color: '#999' }}>לא נקבע</span>;
            }
            return (
              <label>
                {dateUtils.displayFormatDate(rowData.courseStartDate)}
              </label>
            );
          }}
        />
      </DataTable>
    </div>
  );
};
